import { useSearchParams } from "react-router-dom";

import { CategoryTypes } from "../constants/enums";

const useCategoriesNavigation = (type?: CategoryTypes) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const mainCategoryId = searchParams.get(
    CategoryTypes.MAIN_CATEGORY
  ) as string;
  const subCategoryId = searchParams.get(CategoryTypes.SUB_CATEGORY) as string;
  const subChildCategoryId = searchParams.get(
    CategoryTypes.SUB_CHILD_CATEGORY
  ) as string;

  const onChangeCategoryId = (categoryId: string) => {
    if (type === CategoryTypes.MAIN_CATEGORY) {
      return setSearchParams({ [CategoryTypes.MAIN_CATEGORY]: categoryId });
    }

    if (type === CategoryTypes.SUB_CATEGORY) {
      return setSearchParams({
        [CategoryTypes.MAIN_CATEGORY]: mainCategoryId,
        [CategoryTypes.SUB_CATEGORY]: categoryId
      });
    }

    if (type === CategoryTypes.SUB_CHILD_CATEGORY) {
      return setSearchParams({
        [CategoryTypes.MAIN_CATEGORY]: mainCategoryId,
        [CategoryTypes.SUB_CATEGORY]: subCategoryId,
        [CategoryTypes.SUB_CHILD_CATEGORY]: categoryId
      });
    }
  };

  const resetCategoriesIds = () => {
    setSearchParams({});
  };

  return {
    currentCategoryId: type ? searchParams.get(type) : null,
    mainCategoryId,
    subCategoryId,
    subChildCategoryId,
    onChangeCategoryId,
    resetCategoriesIds
  };
};

export default useCategoriesNavigation;
